// OpenObserve RUM (Real User Monitoring) + browser logs bootstrap.
//
// This module is additive-only observability: it must never throw, never block
// render, and must no-op entirely when the client token is not configured.
import { openobserveLogs } from '@openobserve/browser-logs';
import { openobserveRum } from '@openobserve/browser-rum';

const APPLICATION_ID = 'frontend-video';
const SERVICE_NAME = 'frontend-video';

const SHARED_CONFIG = {
    site: 'monitor.incruiter.com',
    organizationIdentifier: 'default',
    env: 'development',
    version: '0.0.1',
    insecureHTTP: false,
    apiVersion: 'v1',
};

// Same-origin requests, or anything hosted on an *.incruiter.com domain, are
// treated as "our" backends for distributed tracing header propagation.
const isAllowedTracingUrl = (url) => {
    try {
        const parsed = new URL(url, window.location.origin);
        return parsed.origin === window.location.origin || /(^|\.)incruiter\.com$/i.test(parsed.hostname);
    } catch {
        return false;
    }
};

export function initRum() {
    if (typeof window === 'undefined') return;

    // OPENOBSERVE_CLIENT_TOKEN is a public, write-only RUM token injected at build time.
    const clientToken = process.env.REACT_APP_OPENOBSERVE_CLIENT_TOKEN;
    if (!clientToken) return;

    try {
        openobserveRum.init({
            applicationId: APPLICATION_ID,
            service: SERVICE_NAME,
            clientToken,
            ...SHARED_CONFIG,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'mask',
            allowedTracingUrls: [
                { match: isAllowedTracingUrl, propagatorTypes: ['tracecontext', 'openobserve'] },
            ],
        });

        openobserveRum.startSessionReplayRecording();

        openobserveLogs.init({
            applicationId: APPLICATION_ID,
            service: SERVICE_NAME,
            clientToken,
            ...SHARED_CONFIG,
            forwardErrorsToLogs: true,
        });
    } catch (err) {
        console.warn('[OpenObserve RUM] Failed to initialize', err);
    }
}
